import React from "react"

import "~/components/Label/Label"
import "./TextField.scss"
import Label from "~/components/Label/Label"
import classNames from "classnames"

export type TextFieldProps = {
  label?: string
  placeholder?: string
  style?: "light" | "dark"
  autofocus?: boolean
  id?: string
  type?: string
  regex?: RegExp
  name?: string
  disabled?: boolean
  maxLength?: number
  value: string
  valueChanged?: (value: string) => void
  className?: string
}

function TextField({
  label,
  placeholder,
  style = "dark",
  autofocus,
  id,
  type = "text",
  regex,
  name,
  disabled,
  maxLength,
  className,
  valueChanged,
  value,
}: TextFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let input = event.target.value
    if (regex) {
      input = event.target.value.replace(regex, "")
    }

    valueChanged?.(input)
  }

  return (
    <div className={classNames("TextField", `TextField--${style}`, className)}>
      {label ? <Label text={label} htmlFor={id} /> : ""}
      <input
        autoFocus={autofocus}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        id={id}
        type={type}
        name={name}
        disabled={disabled}
        maxLength={maxLength}
      />
    </div>
  )
}

export default TextField
